import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { AccessoriesProcess } from '../../features';
import { useOrder } from '../../context/OrderContext';
import { Header } from '../../layout';

const AccessoriesProcessPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { accessoryType } = useParams();
    const { state: orderState } = useOrder();

    // Check if we're in edit mode
    const isEditMode = location.state?.editMode;
    // Get the index of the item being edited from the cart
    const editItemIndex = location.state?.itemIndex;
    // Check if we're coming from profile configuration flow
    const fromProfileConfiguration = location.state?.fromProfileConfiguration;
    const profileType = location.state?.profileType;

    const handleAccessoriesComplete = (accessoryConfig) => {
        if (!isEditMode) {
            // Always show confirmation page, regardless of source
            navigate('/accessories-confirmation', {
                state: {
                    profileType: profileType,
                    fromProfileConfiguration: fromProfileConfiguration,
                    completedAccessory: accessoryType
                }
            });
        } else {
            // If in edit mode, navigate back to the previous page
            navigate(-1);
        }
    };

    // Get the title based on accessory type
    const getTitle = () => {
        switch (accessoryType) {
            case 'giunzioni':
                return 'Seleziona Giunzioni';
            case 'corrimano':
                return 'Seleziona Corrimano';
            case 'coprifilo':
                return 'Seleziona Angolare e Coprifilo';
            case 'led':
                return 'Seleziona Profilo LED';
            case 'tappi':
                return 'Seleziona Tappi NINFA';
            case 'spessori':
                return 'Seleziona Spessori';
            default:
                return 'Seleziona Accessori';
        }
    };

    return (
        <div className="min-h-screen bg-gray-100">
            <Header title={getTitle()} />

            <div className="container mx-auto px-4 py-8">
                <div className="flex items-center mb-4">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center text-gray-600 hover:text-gray-800"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        Torna agli accessori
                    </button>
                </div>

                <AccessoriesProcess
                    accessoryType={accessoryType}
                    onComplete={handleAccessoriesComplete}
                    isEditMode={isEditMode}
                    editItemIndex={editItemIndex}
                    profileType={profileType}
                />
            </div>
        </div>
    );
};

export default AccessoriesProcessPage;
